import { __ } from '@oat-sa-private/ui-core';

export const defaultThemeKey = 'default';
export const themeLabels = {
    [defaultThemeKey]: __('Default'),
    whiteOnBlack: __('White On Black'),
    whiteOnBlue: __('White On Blue'),
    yellowOnBlack: __('Yellow On Black'),
    yellowOnBlue: __('Yellow On Blue'),
    blueOnYellow: __('Blue On Yellow'),
    blackOnCream: __('Black On Cream'),
    blackOnBlue: __('Black On Blue'),
    blackOnMagenta: __('Black On Magenta'),
    greyOnGreen: __('Grey On Green')
};
export const themeColours = {
    whiteOnBlack: '--theme-white-on-black',
    whiteOnBlue: '--theme-white-on-blue',
    yellowOnBlack: '--theme-yellow-on-black',
    yellowOnBlue: '--theme-yellow-on-blue',
    blueOnYellow: '--theme-blue-on-yellow',
    blackOnCream: '--theme-black-on-cream',
    blackOnBlue: '--theme-black-on-blue',
    blackOnMagenta: '--theme-black-on-magenta',
    greyOnGreen: '--theme-grey-on-green'
};
